import {
  COMPETITIVE_RULESET,
  type RunResult,
} from "./RunStats";

export const PUBLIC_CANONICAL_URL = "https://sol-katamari.pages.dev/";
export const RESULT_HASHTAG = "SolKatamari";
export const TWITTER_INTENT_URL = "https://twitter.com/intent/tweet";
export const TWEET_TEXT_LIMIT = 280;

export function formatResultTime(timeSeconds: number): string {
  if (!Number.isFinite(timeSeconds) || timeSeconds < 0) {
    throw new RangeError("timeSeconds must be a finite, non-negative number");
  }

  // Never display a time that is faster than the exact value used for rank.
  const tenths = Math.ceil(timeSeconds * 10);
  const minutes = Math.floor(tenths / 600);
  const seconds = Math.floor((tenths % 600) / 10);
  const decimal = tenths % 10;
  return `${minutes}:${seconds.toString().padStart(2, "0")}.${decimal}`;
}

export function canonicalResultUrl(_sourceUrl = PUBLIC_CANONICAL_URL): string {
  // Results always point at the stable production entry point. This deliberately
  // drops replay/debug query parameters and preview-deployment hostnames.
  const canonical = new URL(PUBLIC_CANONICAL_URL);
  canonical.search = "";
  canonical.hash = "";
  return canonical.toString();
}

function limitTweetText(text: string): string {
  const codePoints = Array.from(text);
  return codePoints.length <= TWEET_TEXT_LIMIT
    ? text
    : codePoints.slice(0, TWEET_TEXT_LIMIT).join("");
}

export function buildResultShareText(result: Readonly<RunResult>): string {
  const ruleset = result.ruleset || COMPETITIVE_RULESET;
  return limitTweetText(
    [
      "🗼 SOL KATAMARIをクリア！",
      `⏱ ${formatResultTime(result.timeSeconds)} / RANK ${result.rank}`,
      `⭐ ${result.score.toLocaleString("ja-JP")}点 / レア ${result.rareCount}個`,
      `ルールセット: ${ruleset}`,
    ].join("\n"),
  );
}

export function buildResultShareUrl(
  result: Readonly<RunResult>,
  sourceUrl = PUBLIC_CANONICAL_URL,
): string {
  const intent = new URL(TWITTER_INTENT_URL);
  intent.searchParams.set("text", buildResultShareText(result));
  intent.searchParams.set("url", canonicalResultUrl(sourceUrl));
  intent.searchParams.set("hashtags", RESULT_HASHTAG);
  return intent.toString();
}
